import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { submitVatDeclaration } from '../query-api'

interface UseSubmitVatDeclarationProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useSubmitVatDeclaration = (props?: UseSubmitVatDeclarationProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate, ...rest } = useMutation(submitVatDeclaration, {
    onError,
    onSuccess,
  })

  return { mutate, ...rest }
}
